export default "__VITE_ASSET__LhiCgnUt__"